// extracted by mini-css-extract-plugin
module.exports = {"invoiceList":"invoiceList_invoiceList__qIU5e","rowhold":"invoiceList_rowhold__3tAeu","row":"invoiceList_row__3cnYY"};